<template>
	<section class="shopping">
		<span v-if="isAuth"></span>
		<div class="shopping__inner _cnt">
			<div class="shopping__content">
				<div class="shopping__title _h1">
					{{ $t('Get Started Now') }}
				</div>
				<div class="shopping__line _line"><span></span></div>
				<div class="shopping__text _text-secondary">
					{{
						$t(
							'Upgrade your inventory or turn your collection into profit. The smoke clears fast — trade smarter today.'
						)
					}}
				</div>
				<router-link
					v-if="!isAuth"
					class="shopping__link _btn-primary"
					to="/singup"
					><span>{{ $t('Register') }}</span>
					<span>
						<svg
							width="23"
							height="23"
							viewBox="0 0 23 23"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M22.5 11.25C22.5 5.037 17.463 0 11.25 0C5.037 0 0 5.037 0 11.25C0 17.463 5.037 22.5 11.25 22.5C17.463 22.5 22.5 17.463 22.5 11.25ZM11.8856 13.4786C11.8856 13.3129 11.7513 13.1786 11.5856 13.1786H5.175C5.00932 13.1786 4.875 13.0443 4.875 12.8786V9.62137C4.875 9.45569 5.00931 9.32138 5.175 9.32138H11.5856C11.7513 9.32138 11.8856 9.18706 11.8856 9.02138V5.99763C11.8856 5.72713 12.2154 5.59479 12.4024 5.79026L17.4266 11.0426C17.5376 11.1586 17.5376 11.3414 17.4266 11.4574L12.4024 16.7097C12.2154 16.9052 11.8856 16.7729 11.8856 16.5024V13.4786Z"
								fill="white"
							/>
						</svg>
					</span>
				</router-link>
				<router-link
					v-else
					class="shopping__link _btn-primary"
					to="/products/all"
					><span>{{ $t('Explore market') }}</span>
					<span>
						<svg
							width="23"
							height="23"
							viewBox="0 0 23 23"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M22.5 11.25C22.5 5.037 17.463 0 11.25 0C5.037 0 0 5.037 0 11.25C0 17.463 5.037 22.5 11.25 22.5C17.463 22.5 22.5 17.463 22.5 11.25ZM11.8856 13.4786C11.8856 13.3129 11.7513 13.1786 11.5856 13.1786H5.175C5.00932 13.1786 4.875 13.0443 4.875 12.8786V9.62137C4.875 9.45569 5.00931 9.32138 5.175 9.32138H11.5856C11.7513 9.32138 11.8856 9.18706 11.8856 9.02138V5.99763C11.8856 5.72713 12.2154 5.59479 12.4024 5.79026L17.4266 11.0426C17.5376 11.1586 17.5376 11.3414 17.4266 11.4574L12.4024 16.7097C12.2154 16.9052 11.8856 16.7729 11.8856 16.5024V13.4786Z"
								fill="white"
							/>
						</svg>
					</span>
				</router-link>
			</div>
			<div class="shopping__bg shopping__bg_1 _ibg-contain">
				<img src="@/assets/img/bg/shopping/01.png" />
			</div>
			<div class="shopping__bg shopping__bg_2 _ibg-contain">
				<img src="@/assets/img/bg/shopping/02.png" />
			</div>
			<div class="shopping__bg shopping__bg_3 _ibg-contain">
				<img src="@/assets/img/bg/shopping/03.png" />
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'StartShoppingSection',
	components: {},
	props: {
		isAuth: { type: Boolean },
	},
	methods: {
		sellSkin() {
			if (this.isAuth) {
				this.$emit('openSellSkinModal');
			} else {
				this.$router.push('/signin');
			}
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/fonts' as *;
@use '@/assets/styles/components/classes' as *;

//========================================================================================================================================================


.shopping {
	position: relative;
	overflow: hidden;
	@include adaptiveValue('padding-top', 150, 40);
	@include adaptiveValue('padding-bottom', 100, 25);
	@media (max-width: $md2) {
		&::before {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			background-color: var(--bg-fifth-color);
		}
	}
	&__inner {
	}
	&__content {
		max-width: 695px;
		margin-right: auto;
		position: relative;
		z-index: var(--base-z-index);
	}
	&__title,
	&__line,
	&__text {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
	}
	&__link {
		width: 100%;
		max-width: 365px;
		display: flex;
		align-items: center;
		gap: 10px;
		span {
			display: flex;
			align-items: center;
			height: 23px;
		}
	}
	&__bg {
		position: absolute;
		right: 0px;
		bottom: 0px;
		&_1 {
			width: 65%;
			padding-bottom: 4%;
			z-index: -1;
			@media (max-width: $md2) {
				width: 75%;
				padding-bottom: 10%;
			}
			@media (max-width: $md3) {
				width: 85%;
				padding-bottom: 40%;
			}
			@media (max-width: $md4) {
				width: 90%;
				padding-bottom: 50%;
			}
		}
		&_2 {
			width: 35%;
			padding-bottom: 31.5%;
			z-index: -2;
			@media (max-width: $md2) {
				width: 45%;
				padding-bottom: 40%;
			}
			@media (max-width: $md3) {
				width: 55%;
				padding-bottom: 50%;
			}
			@media (max-width: $md4) {
				width: 65%;
				padding-bottom: 60%;
			}
		}
		&_3 {
			width: 65%;
			padding-bottom: 20.5%;
			z-index: -3;
			@media (max-width: $md2) {
				width: 75%;
				padding-bottom: 30%;
			}
			@media (max-width: $md3) {
				width: 85%;
				padding-bottom: 40%;
			}
			@media (max-width: $md4) {
				width: 90%;
				padding-bottom: 50%;
			}
		}
	}
}
</style>
